import React from 'react'
import { Container, Header } from 'semantic-ui-react'
import PartnerGrid from './partnerGrid'

const images = require.context('./images', true)

const PartnerMap = ({ id, headline, subline, partners }) => {
  const getPartnerLogo = (img) => images(`./${img}`)

  return (
    <section id={id} className="partner-section">
      <Container>
        <article className="article mobile-stack">
          <div className="article__txt">
            <Header className="headline-regular" as="h1">
              {headline}
            </Header>
            <Header className="headline-bag" as="h3">
              {subline}
            </Header>

            <PartnerGrid
              partners={partners}
              getLogo={getPartnerLogo}
            />
          </div>
        </article>
      </Container>
    </section>
  )
}

export default PartnerMap
